module.exports = __webpack_public_path__ + "media/bootstrap-icons/geo-fill-69d0eb5c.svg";